import { NullableResultPromise } from "../base-types";
import CultureInfo from "../culture-info";
import Guard from "../guard";
import { ICultureLoader } from "./culture-loader";

/**
 * Allows fetching culture information.
 */
export interface ICultureClient {
    /**
     * Gets the default culture.
     * @returns The default culture.
     */
    getDefaultCultureAsync(): NullableResultPromise<CultureInfo>;

    /**
     * Gets the cached default culture.
     * @returns The default culture.
     */
    getDefaultCultureCachedAsync(): NullableResultPromise<CultureInfo>;

    /**
     * Gets all installed cultures.
     * @returns All installed cultures.
     */
    getAllCulturesAsync(): Promise<Array<CultureInfo>>;

    /**
     * Gets all cached installed cultures.
     * @returns All cached installed cultures.
     */
    getAllCulturesCachedAsync(): Promise<Array<CultureInfo>>;
}

export class CultureClient implements ICultureClient {
    private readonly _cultureLoader: ICultureLoader;

    constructor(cultureLoader: ICultureLoader) {
        Guard.notNullOrUndefined(cultureLoader);

        this._cultureLoader = cultureLoader;
    }

    async getAllCulturesAsync(): Promise<Array<CultureInfo>> {
        return await this._cultureLoader.getAllCulturesAsync();
    }

    async getAllCulturesCachedAsync(): Promise<Array<CultureInfo>> {
        return await this._cultureLoader.getAllCulturesCachedAsync();
    }

    async getDefaultCultureAsync(): NullableResultPromise<CultureInfo> {
        return await this._cultureLoader.getDefaultCultureAsync();
    }

    async getDefaultCultureCachedAsync(): NullableResultPromise<CultureInfo> {
        return await this._cultureLoader.getDefaultCultureCachedAsync();
    }
}
